import { request } from './client';

/**
 * The whole Game Progress board in one call: every round the game has played, newest
 * first, with who was in it, what they picked and how it went.
 *
 * <p>Replaces a fan-out that grew with the season - the screen used to ask for one week's
 * selections per week played, then reassemble them in the browser. Twenty rounds meant
 * twenty requests before anything drew.
 *
 * <p>It also decides concealment, which the browser cannot. A pick for a round that has
 * not locked is simply not in the response; the old endpoint sent every player's team and
 * relied on the screen not to draw it.
 */
export function getGameProgress(gameId) {
  return request(`/api/customer/games/${gameId}/progress`);
}
